export default __webpack_public_path__ + "static/media/mb-cta-chevron-white.37119a63.svg";